import { Pipe, PipeTransform } from '@angular/core';

/**
 * Single source of truth for how account roles are shown to users. Keeps
 * terminology consistent across the app and turns raw codes (e.g. "platform_admin")
 * into clean labels. Backend role codes are intentionally left unchanged.
 */
const ROLE_LABELS: Record<string, string> = {
  patient: 'Patient',
  doctor: 'Clinician',
  proxy: 'Designated Proxy',
  admin: 'Organization Admin',
  platform_admin: 'Platform Admin',
  notary: 'Notary',
  witness: 'Witness',
};

@Pipe({ name: 'roleLabel' })
export class RoleLabelPipe implements PipeTransform {
  public transform(value: string | null | undefined): string {
    if (!value) {
      return '';
    }
    const key = String(value).toLowerCase();
    return ROLE_LABELS[key] ?? value.charAt(0).toUpperCase() + value.slice(1);
  }
}
